import { useState } from "react";
import type { NewsItem } from "@/types/movie";
import { newsList } from "@/mocks/news";
import { formatDate } from "@/lib/movies";

export default function NewsSection() {
  const [active, setActive] = useState<NewsItem | null>(null);

  return (
    <section className="w-full px-4 md:px-8 mt-10 md:mt-14">
      <div className="flex items-end justify-between mb-5">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            影视资讯与推荐
          </h2>
          <p className="mt-1 text-sm text-foreground-500">行业动态、追剧指南与深度解读</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
        {newsList.map((item, index) => (
          <button
            key={item.id}
            type="button"
            onClick={() => setActive(item)}
            className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 text-left transition-colors hover:border-primary-300 cursor-pointer"
          >
            <span
              className={`shrink-0 w-10 h-10 flex items-center justify-center rounded-lg font-heading text-lg font-bold ${
                index === 0
                  ? "bg-accent-100 text-accent-800"
                  : "bg-primary-50 text-primary-700"
              }`}
            >
              {index + 1}
            </span>
            <span className="min-w-0">
              <span className="flex flex-wrap items-center gap-2 mb-1.5">
                <span className="rounded-md bg-secondary-100 text-secondary-900 text-xs px-2 py-0.5">
                  {item.category}
                </span>
                <span className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-calendar-line" />
                  {formatDate(item.date)}
                </span>
              </span>
              <span className="block font-medium text-foreground-950 leading-6 line-clamp-1 group-hover:text-primary-600 transition-colors">
                {item.title}
              </span>
              <span className="mt-1.5 block text-sm text-foreground-500 line-clamp-2">
                {item.excerpt}
              </span>
            </span>
          </button>
        ))}
      </div>

      {active && (
        <div
          className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-foreground-950/60 animate-fade-in"
          onClick={() => setActive(null)}
          role="dialog"
          aria-modal="true"
        >
          <div
            className="w-full max-w-lg rounded-lg bg-background-50 p-6 md:p-7 animate-scale-in"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-start justify-between gap-4 mb-3">
              <span className="rounded-md bg-secondary-100 text-secondary-900 text-xs px-2 py-0.5">
                {active.category}
              </span>
              <button
                type="button"
                onClick={() => setActive(null)}
                className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-500 hover:bg-background-100 cursor-pointer"
                aria-label="关闭"
              >
                <i className="ri-close-line text-xl" />
              </button>
            </div>
            <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 leading-7 mb-2">
              {active.title}
            </h3>
            <p className="text-xs text-foreground-400 mb-4 flex items-center gap-1">
              <i className="ri-calendar-line" />
              {formatDate(active.date)}
            </p>
            <p className="text-sm leading-7 text-foreground-700">
              {active.excerpt}
              天天影院将持续为你带来最新的影视动态与观影指南，本文内容为演示资讯，更多深度报道敬请期待。
            </p>
          </div>
        </div>
      )}
    </section>
  );
}